export default __webpack_public_path__ + "static/media/rachel-left.7feb1a3d.png";